
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_1lx8j_210",
  "button": "awsui_button_vjswe_1lx8j_214",
  "variant-normal": "awsui_variant-normal_vjswe_1lx8j_275",
  "disabled": "awsui_disabled_vjswe_1lx8j_296",
  "variant-primary": "awsui_variant-primary_vjswe_1lx8j_304",
  "variant-link": "awsui_variant-link_vjswe_1lx8j_333",
  "variant-icon": "awsui_variant-icon_vjswe_1lx8j_362",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_1lx8j_391",
  "variant-inline-icon-pointer-target": "awsui_variant-inline-icon-pointer-target_vjswe_1lx8j_420",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_1lx8j_449",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_1lx8j_482",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_1lx8j_511",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_1lx8j_540",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_1lx8j_574",
  "button-no-text": "awsui_button-no-text_vjswe_1lx8j_670",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_1lx8j_674",
  "full-width": "awsui_full-width_vjswe_1lx8j_677",
  "button-compact": "awsui_button-compact_vjswe_1lx8j_694",
  "icon-left": "awsui_icon-left_vjswe_1lx8j_704",
  "icon-right": "awsui_icon-right_vjswe_1lx8j_709",
  "icon": "awsui_icon_vjswe_1lx8j_704",
  "link": "awsui_link_vjswe_1lx8j_728",
  "disabled-with-reason": "awsui_disabled-with-reason_vjswe_1lx8j_728"
};
  